var render = function () {var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;
return _c('construction-page',{attrs:{"text-title":_vm.textTitle,"image-play":_vm.imagePlay,"image-mark":_vm.imageMark,"image-background":_vm.imageBackground,"color-main":_vm.colorMain,"color-text":_vm.colorText}});}
var staticRenderFns = []

export { render, staticRenderFns }